import React, {Component} from 'react';

import Workflow from "../core/Workflow";
import axios from "axios";
import AuthService from "../../AuthService";
import UploadImages from "../util/upload-files.component";

class Bateau extends Component {
    constructor(props) {
        super(props);

        this.wowkflow = React.createRef();

        this.state = {
            workflowInitData : {
                WORKFLOW_ID: 5,
                PARAM_bateauId: this.props.match.params.bateauId,
                PARAM_utilisateurId: 1, // TODO récupérer l'ID du localStorage stocké à partir du token
            },
            bateauId: this.props.match.params.bateauId
        }

        this.coreChange = this.coreChange.bind(this);
        this.coreSubmit = this.coreSubmit.bind(this);
        this.coreExternalCall = this.coreExternalCall.bind(this);
    }

    coreChange(e) {
        if (e.target.name === "BLOCK_ITEM_5010101" && !(this.state.bateauId) && !!(e.target.value)) {
            document.location = "/admin/bateau/" + e.target.value;
        }
    }

    async coreExternalCall(method) {
        if (method === "delete") {
            await axios.post(AuthService.getUrl('/deleteBateau'), {id: this.state.bateauId}, AuthService.getAuthHeader()).then(
                res => {
                    this.props.history.push('/admin/flotte');
                }
            );
        }
        if (method === "leave") {
            this.props.history.push('/admin/flotte');
        }
    }

    coreSubmit(data) {
        if (!!data) {
            data.screen.blocks[0].blockItems.map(blockItem => {
                if (blockItem.id === 5010101) {
                    this.state.bateauId = blockItem.values[0];
                }
            });
        }
    }

    render() {
        return (
            <div className="responsiveForm">
                {!!(this.state.errorMessage) &&
                    <div className="errorMessage">
                        <span>{this.state.errorMessage}</span>
                    </div>
                }
                {!!(this.state.validMessage) &&
                    <div className="actionMessage">
                        <span>{this.state.validMessage}</span>
                    </div>
                }
                <Workflow   ref={this.wowkflow}
                            initData={this.state.workflowInitData}
                            onChange={this.coreChange}
                            onSubmit={this.coreSubmit}
                            externalCall={this.coreExternalCall}
                            primaryKey={this.state.bateauId}/>

                <UploadImages bateauId={this.state.bateauId}/>
            </div>
        );
    }
}

export default Bateau;
